import { Box, List, useMediaQuery, useTheme } from '@mui/material';
import SidebarItem from 'components/Layouts/components/SidebarItem';
import * as urls from 'routes/config';
import { Outlet } from 'react-router-dom';

export default function Developers() {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      display='flex'
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={{ xs: 0, md: 4 }}
      minHeight='calc(100vh - 64px)'
      sx={{ width: '100%' }}
    >
      {!isMediumScreen ? (
        <List
          sx={{
            minWidth: { md: 162, lg: 200 },
            maxWidth: { md: 200, lg: 262 },
            height: 'fit-content',
            background: theme.palette.background.paper,
            borderRadius: 2,
            position: 'sticky',
            top: { md: '120px', lg: '200px' },
            flexShrink: 0
          }}
        >
          <SidebarItem to={urls.developers.apiKeys} label='API Keys' />
          <SidebarItem to={urls.developers.webhooks} label='Webhook' />
        </List>
      ) : (
        <List
          sx={{
            display: 'flex',
            flexDirection: 'row',
            height: 'fit-content',
            background: theme.palette.background.paper,
            borderRadius: '12px',
            position: 'fixed',
            bottom: '0px',
            left: { xs: '12px', sm: '24px' },
            right: { xs: '12px', sm: '24px' },
            overflowX: 'auto',
            overflowY: 'hidden',
            zIndex: 1000,
            backgroundColor: theme.palette.background.default,
            padding: { xs: '8px', sm: '12px' },
            gap: { xs: 1, sm: 1.5 },
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          <SidebarItem type='mobile' to={urls.developers.apiKeys} label='API Keys' />
          <SidebarItem type='mobile' to={urls.developers.webhooks} label='Webhook' />
        </List>
      )}
      <Box
        width='100%'
        sx={{
          paddingBottom: { xs: '80px', md: '100px' },
          paddingX: { xs: 0, md: 0 },
          overflowX: 'hidden'
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
